import { Box, styled, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CHIP_COLOR } from '../utility/Constant';

export const MuiAutocompleteWithFocus = {
    '& .MuiInputBase-root': {
        borderRadius: '8px',
        boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
        padding: '0',
        paddingLeft: '9px!important',
        paddingRight: '9px!important',
        height: '50px',
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f',
    },
    '& .MuiOutlinedInput-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.10)',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 108, 221, 1)',
    },
};
export const MuiDisabledAutocomplete = {
    '& .MuiInputBase-root': {
        backgroundColor: '#F1F1F1',
        borderRadius: '8px',
        boxShadow: 'none',
        padding: '0',
        paddingLeft: '9px!important',
        paddingRight: '9px!important',
        height: '50px',
    },
    '& fieldset': {
        border: 'none',
    },
    '& .Mui-disabled': {
        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.70)!important',
    },
};

export const MuiTextFieldWithFocus40 = {
    '& .MuiInputBase-root': {
        borderRadius: '8px!important',
        boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)!important',
        height: '40px!important',
        fontSize: '14px',
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f!',
    },
    '& .MuiOutlinedInput-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.10)',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 108, 221, 1)',
    },
};
export const MuiTextFieldWithFocus4016 = {
    '& .MuiInputBase-root': {
        borderRadius: '8px!important',
        boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)!important',
        height: '40px!important',
        fontSize: '16px',
        paddingRight: '5px!important',
        paddingLeft: '10px!important',
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f',
    },
    '& .MuiOutlinedInput-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.10)',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 108, 221, 1)',
    },
};
export const MuiDisablesTextFieldWithFocus4016 = {
    '& .MuiInputBase-root': {
        borderRadius: '8px!important',
        backgroundColor: '#F1F1F1',
        boxShadow: 'none',
        height: '40px!important',
        fontSize: '16px',
        paddingRight: '5px!important',
        paddingLeft: '10px!important',
    },
    '& fieldset': {
        border: 'none',
    },
    '& .Mui-disabled': {
        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.70)!important',
    },
};

export const MuiDisablesTextFieldWithFocus40 = {
    '& .MuiInputBase-root': {
        borderRadius: '8px!important',
        backgroundColor: '#F1F1F1',
        boxShadow: 'none',
        height: '40px!important',
        fontSize: '14px',
    },
    '& fieldset': {
        border: 'none',
    },
    '& .Mui-disabled': {
        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.70)!important',
    },
};

export const MuiTextFieldWithFocus = {
    '& .MuiInputBase-root': {
        borderRadius: '8px',
        boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
        height: '50px',
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f',
    },
    '& .MuiOutlinedInput-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.10)',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 108, 221, 1)',
    },
};

export const MuiMultiFieldWithFocus = {
    '& .MuiInputBase-root': {
        borderRadius: '8px',
        boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f',
    },
    '& .MuiOutlinedInput-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.10)',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 108, 221, 1)',
    },
};

export const MuiDisabledTextField = {
    '& .MuiInputBase-root': {
        borderRadius: '8px',
        boxShadow: 'none',
        height: '50px',
        backgroundColor: '#F1F1F1',
    },

    '& fieldset': {
        border: 'none',
    },
    '& .Mui-disabled': {
        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.70)!important',
    },
};

export const MuiSelectWithFocus = {
    height: '50px',
    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
    borderRadius: '8px',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.10)',
    },
};
export const MuiSelectWithFocus40 = {
    height: '40px',
    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
    borderRadius: '8px',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.10)',
    },
};
export const MuiDisabledSelect40 = {
    height: '40px',
    boxShadow: 'none',
    borderRadius: '8px',
    backgroundColor: '#F1F1F1',
    '& fieldset': {
        border: 'none',
    },
    '& .Mui-disabled': {
        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.70)!important',
    },
};
export const MuiDisabledSelect = {
    height: '50px',
    boxShadow: 'none',
    borderRadius: '8px',
    backgroundColor: '#F1F1F1',
    '& fieldset': {
        border: 'none',
    },
    '& .Mui-disabled': {
        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.70)!important',
    },
};

export const MuiDisabledRadioGroup = {
    '& .Mui-disabled': {
        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.70)!important',
    },
};

// Custom styled percentage badge
export const PercentageBadge = styled(Box)(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, 0.08)', // Light gray background
    width: 'max-content',
    borderRadius: '100px!important',
    padding: '2px 6px',
    fontSize: 13,
    fontWeight: 500,
    lineHeight: '18px',
    marginLeft: 'auto',
}));

//Active TableSortLabel UI
export const activeTableSortLabel = {
    '& .MuiTableSortLabel-icon': {
        color: '#006CDD!important',
        background: '#E6F1FC',
        borderRadius: '50%',
    },
};

//Payment Text Field
export const paymentTextField = {
    marginLeft: 'auto',

    '& .MuiOutlinedInput-input': {
        padding: '2px 6px',
        paddingLeft: '0px!important',
        fontSize: '14px',
        height: '23px',
    },
    '& .MuiOutlinedInput-root ': {
        paddingLeft: '0px !important',
    },
    '& fieldset': { border: 'none' },
    width: '80px',
};
//Chip Styke
export const chipStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    borderRadius: '44px',
    height: '40px',
    width: 'max-content',
    color: CHIP_COLOR.DEFAULT_COLOR,
    fontWeight: '500',
    fontSize: '16px',
};

export const MuiEllipseStyle = {
    '& .MuiInputBase-input': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        paddingRight: '40px !important', // Ensure space for endAdornment
    },
};

export const MuiButtonWithIcon = {
    marginTop: '16px',
    padding: '8px 16px 8px 12px!important',
    width: 'max-content',
    height: 42,
    borderRadius: '4px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2px',
};

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
        margin: 0,
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderRadius: '8px',
        '&:not(:first-of-type)': {
            marginLeft: '0',
            borderRadius: '8px',
        },
        '&:first-of-type': {
            borderRadius: '8px',
        },
    },
}));

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    padding: '8px 16px',
    fontSize: '16px',
    height: '40px',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '0.15px',
    textTransform: 'none',
    color: '#000',
    backgroundColor: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '100px!important',
    '&.Mui-selected': {
        backgroundColor: '#007AFF',
        color: '#fff',
        border: '1px solid #0066E1',
        '&:hover': {
            backgroundColor: '#0066E1',
        },
    },
    '&:not(.Mui-selected)': {
        backgroundColor: '#fff',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        border: '1px solid #DCDCDC',
        '&:hover': {
            backgroundColor: '#fff',
        },
    },
}));
